import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const CommonModal = ({ open, onClose, title, children, actions }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        {title && (
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom sx={{ textAlign: 'center',color:"red" }}>
            {title}
          </Typography>
        )}
        <Box id="modal-description" sx={{ mb: 4 }}>
          {children}
        </Box>
        {actions && (
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
            {actions}
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default CommonModal;
